<script lang="ts">
  import {fade} from 'svelte/transition'
  import {modal} from '../stores/modal'

  $: (document.body as HTMLBodyElement).style.overflow = $modal ? 'hidden' : ''

  function handleEscape(e: KeyboardEvent) {
    if ($modal && e.key === 'Escape') modal.close()
  }

  function close() {
    modal.close()
  }
</script>

<svelte:body onkeyup={handleEscape}/>

{#if $modal}
  <div class="modal-backdrop" onclick={close} transition:fade={{duration: 500}}/>
  <svelte:component this={$modal.component} {...$modal.props}/>
{/if}

<style>
  .modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: hidden;
    background: rgba(0, 0, 0, 0.5);
    z-index: 50;
  }

  .modal-positioner {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 51;
  }
</style>